/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { Icon, Button, Header, Form, Modal, Label } from 'semantic-ui-react'

import NameField from '../fields/nameField'
import CodeField from '../fields/codeField'
import PublishField from '../fields/publishField'
import DescriptionField from '../fields/descriptionField'
import PriceField from '../fields/priceField'

export default class BranchForm extends React.PureComponent {
  state = {
    label: '',
  }

  dropdownRef = React.createRef()

  btnSubmitRef = React.createRef()

  componentDidMount() {
    const { action, itemData } = this.props

    if (action === 'edit') {
      this.setState({ label: `Edit ${itemData.name}` })
    }
  }

  getTags = () => {
    const { storeData, tags } = this.props

    const options = _.map(storeData.tags || {}, (tag, tagKey) => ({
      key: tagKey,
      value: tagKey,
      text: tags[tagKey],
    }))

    if (_.size(options) > 0) {
      options.push({ key: 'unselect', value: '@unselect', text: 'Unselect' })
    }

    return options
  }

  onTagChange = (e, { value }) => {
    const { onFieldChange } = this.props

    if (value === '@unselect') {
      value = ''
    }

    onFieldChange('tag', value)
  }

  onSave = e => {
    const { saveItem } = this.props
    e.preventDefault()

    return saveItem()
  }

  render() {
    const { label } = this.state
    const {
      action,
      loading,
      onClose,
      visible,
      itemData,
      itemOptions,
      onFieldChange,
      onOptionOrderChange,
      onRemoveOption,
      arrangeOptions,
    } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Item' : label} />
        <Modal.Content style={{ maxHeight: 600, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <NameField onChange={onFieldChange} value={itemData.name} />
            </Form.Group>
            <Form.Group widths="equal">
              <CodeField onChange={onFieldChange} value={itemData.code} />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Dropdown
                label="Tag"
                placeholder="Select Item Tag"
                fluid
                search
                selection
                value={itemData.tag}
                options={this.getTags()}
                onChange={this.onTagChange}
                ref={ref => {
                  this.dropdownRef = ref
                }}
              />
              <PublishField value={itemData.status} onChange={onFieldChange} />
            </Form.Group>

            <Form.Group widths="equal">
              <PriceField onChange={onFieldChange} value={itemData.current_price} />
            </Form.Group>
            <Form.Group widths="equal">
              <DescriptionField value={itemData.description} onChange={onFieldChange} />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
            {arrangeOptions.length > 0 && (
              <Form.Field>
                <label>Options</label>
                <div>
                  {arrangeOptions.map((optionKey, index) => {
                    if (!itemOptions[optionKey]) return null

                    return (
                      <div style={{ display: 'flex', marginRight: 5, marginBottom: 5 }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <Icon name="angle up" onClick={() => onOptionOrderChange(index, 'up')} />
                          <Icon name="angle down" onClick={() => onOptionOrderChange(index, 'down')} />
                        </div>
                        <Label size="medium" as="a" onClick={() => onRemoveOption(optionKey)} color="blue">
                          {itemOptions[optionKey].name}
                          <Icon name="delete" />
                        </Label>
                      </div>
                    )
                  })}
                </div>
              </Form.Field>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/itemForm.js